import styled from 'styled-components'

import { helpers } from 'styles'

export const ParentKey = styled.span`
	color: ${helpers.color.textMuted};
	opacity: 0.6;
	margin-right: -4px;
`
